<template>
    <Head title="Profile"/>
    <div class="w-screen h-screen bg-gray-700 flex overflow-hidden">
        <div class="">
            <nav class="sidebar-nav">
                <ul>
                    <li class="logo bg-gray-800">
                        <Link :href="route('tour.index')" :title="__('rooomguide.index')">
                            <img class="w-full" src="/assets/img/logo.svg" alt="logo">
                        </Link>
                    </li>
                    <li>
                        <Link :href="route('tour.index')" :title="__('tour.index')">
                            <img src="/assets/icons/icon-menu.svg">
                        </Link>
                    </li>
                </ul>
                <ul class="nav-bottom bg-gradient">
<!--                     <li>
                        <Link :href="route('tour.index')">
                            <img src="/assets/icons/icon-settings.svg">
                        </Link>
                    </li> -->
                    <li>
                        <form @submit.prevent="logout()" class="text-center">
                           <button type="submit">
                                <img src="/assets/icons/icon-logout.svg">
                           </button>
                        </form>
                    </li>
                </ul>
            </nav>
        </div>

        <div class="h-screen w-full">
            <header class="bg-gray-800 flex justify-between px-8 py-2">
                <!-- title area -->
                <div class="flex">
                    <h1 class="text-white text-2xl uppercase font-bold">{{ title }} </h1>
                </div>
                <!-- title area -->
                <Link :href="route('my-area')">
                    <i class="user-circle"></i>
                </Link>
            </header>
            <div class="content pl-8 py-4 overflow-scroll h-full">
                <slot name="user-information"></slot>
                <slot name="provider"></slot>
                <slot name="save-button"></slot>
            </div>
        </div>
    </div>
</template>

<script>
import { Link, Head } from '@inertiajs/inertia-vue3'
import { __ } from '@/locale'

export default {
    data() {
        return {
            __,
        }
    },
    props: {
        title: String,
    },

    components: {
        Link,
        Head,
    },
    methods:{
        logout() {
            this.$inertia.post(route('logout'));
        },
    }
}
</script>
